import { evaluateExpression } from '@appblocks/utils';


export const evaluateStateExpression = async (state: any, exp: any) => {
    const pageContext = getPageContext(state);
    try {
        if (typeof exp === 'string') {
            if (exp.indexOf('{{') === -1) {
                return exp;
            }
            const result = await evaluateExpression(exp, pageContext);
            return result;
        }
        if (Array.isArray(exp)) {
            const items = [...exp];
            for (let i = 0; i < exp.length; i++) {
                // eslint-disable-next-line no-await-in-loop
                items[i] = await evaluateStateExpression(state, exp[i]);
            }
            return items;
        }
        if (typeof exp === 'object') {
            const keys = Object.keys(exp);
            const items: any = {};
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                // eslint-disable-next-line no-await-in-loop
                items[key] = await evaluateStateExpression(state, exp[key]);
            }
            return items;
        }
    } catch (e) {
        return undefined;
    }
};

export const getPageContext = (state: any) => {
    const pageContext = {
        ...state,
        components: {},
        queries: {},
    };
    delete pageContext.app;
    delete pageContext.pageContext;

    for (let i = 0; i < state.components.length; i++) {
        pageContext.components[state.components[i].name] = {};
        if (state.components[i].state.value !== undefined) {
            pageContext
                .components[state.components[i].name].value = state.components[i].state.value;
        }
    }
    for (let i = 0; i < state.queries.length; i++) {
        pageContext.queries[state.queries[i].name] = {
            id: state.queries[i].id,
            ...state.queries[i].state,
        };
    }
    return pageContext;
};
